export const USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{0,38}[a-z0-9]$|^[a-z0-9]$/;

export function normalizePublicUsername(value: string | null | undefined): string {
  const raw = String(value || '').trim().toLowerCase();
  const cleaned = Array.from(raw)
    .filter((character) => /[a-z0-9._-]/i.test(character))
    .join('')
    .replace(/^[._-]+|[._-]+$/g, '')
    .slice(0, 40)
    .replace(/[._-]+$/g, '');
  return cleaned;
}

export function usernameFromEmail(email: string | null | undefined): string {
  const localPart = String(email || '').split('@', 1)[0] || '';
  return normalizePublicUsername(localPart) || 'cityscope-user';
}

export function validatePublicUsername(value: string | null | undefined): string | null {
  const username = normalizePublicUsername(value);
  if (!username) return 'Choose a public username.';
  if (!USERNAME_PATTERN.test(username)) {
    return 'Use letters, numbers, dots, underscores, or hyphens. Start and end with a letter or number.';
  }
  return null;
}
